import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Loading from 'components/Loading'
import Paper from 'components/Paper'
import Iframe from 'features/performance/components/Iframe'
import { PERFORMANCE_IFRAME_HEIGHT } from 'features/performance/constants'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { FormContainer } from './forms/AdminOptionForm/FormContainer'
import { useGetYieldbirdDemandReport } from './hooks/useGetYieldbirdDemandReport/useGetYieldbirdDemandReport'

export const PerformanceYieldbirdDemandPage = (): React.JSX.Element => {
  const { workspaceId } = useWorkspaceParam()
  const ability = useAbility()

  const { t } = useTranslation('common')

  const { yieldbirdDemandReport } = useGetYieldbirdDemandReport({ workspaceId })

  if (!yieldbirdDemandReport) {
    return <Loading />
  }

  const { yieldbirdDemandReportUrl } = yieldbirdDemandReport

  const hasAccess: boolean =
    ability.can('read', 'Performance-adminOption') &&
    ability.can('update', 'Performance-adminOption')

  return (
    <>
      {yieldbirdDemandReportUrl ? (
        <Iframe
          height={PERFORMANCE_IFRAME_HEIGHT}
          src={yieldbirdDemandReportUrl}
        />
      ) : (
        <Paper>
          <Typography>{t('report.notReady')}</Typography>
        </Paper>
      )}

      {hasAccess && <FormContainer data={yieldbirdDemandReport} />}
    </>
  )
}
